var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"com-list--item"},_vm._l((_vm.columns),function(field,fieldIndex){return _c('div',{key:fieldIndex,staticClass:"com-list-view",class:[_vm.rightClass(item, field)]},[_vm._v(" "+_vm._s(item[field.fieldCode])+" ")])}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }